export default function isFiniteExtent(extent) {
    return !extent.some((coordinate) => coordinate === Infinity || coordinate === -Infinity);
}
